import { useEffect, useState } from 'react';
import { Moment } from 'moment';
import { PatientTimeZoneInfoValues } from '../../../Components/Patient/PatientTimeZoneInfo';

interface PatientsTimes {
	timeFrom?: Moment;
	timeTo?: Moment;
}

export default function useTimezoneInfo(
	defaultTimeFrom?: Moment,
	defaultTimeTo?: Moment,
) {
	const [usersTimeDiff, setUsersTimeDiff] = useState<string | null>(null);
	const [patientTimezone, setPatientTimezone] = useState<string | null>(null);
	const [timeFrom, setTimeFrom] = useState<Moment | undefined>(defaultTimeFrom);
	const [timeTo, setTimeTo] = useState<Moment | undefined>(defaultTimeTo);

	const handlePatientTimeDiffChange = ({
		timeDiff,
		patientTimezone,
	}: PatientTimeZoneInfoValues) => {
		setUsersTimeDiff(timeDiff);
		setPatientTimezone(patientTimezone);
	};

	const handleGetPatientsTimes = ({ timeFrom, timeTo }: PatientsTimes) => {
		setTimeFrom(timeFrom);
		setTimeTo(timeTo);
	};

	useEffect(() => {
		if (defaultTimeFrom) {
			setTimeFrom(defaultTimeFrom);
		}
		if (defaultTimeTo) {
			setTimeTo(defaultTimeTo);
		}
	}, [defaultTimeFrom, defaultTimeTo]);

	return {
		usersTimeDiff,
		patientTimezone,
		timeFrom,
		timeTo,
		handleGetPatientsTimes,
		handlePatientTimeDiffChange,
	};
}
